
import Vue from "vue";
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import AppTinyInfo from "./TinyInfo.vue";
import {ChartService} from "@/services";
import { DashboardChartDataWithBanks } from "@/utils/dashboard/dashboard-chart-data-with-banks";


export default Vue.extend({
	data(){
		return {
			totalExpenses: 0.0,
			totalIncome: 0.0
		};
	},
	props: {
		item: {
			type: Object as ()=>DashboardItem,
			required: true
		}
	},
	computed: {
		totalProfit():number{
			return this.totalIncome - this.totalExpenses;
		},
		chartData():DashboardChartDataWithBanks{
			return this.item.Data as DashboardChartDataWithBanks;
		}
	},
	methods: {
		async fetch(){
			this.totalExpenses = await ChartService.getTotalExpense(this.chartData.filters, this.chartData.getBookYearOverrideValue());
			this.totalIncome = await ChartService.getTotalIncome(this.chartData.filters, this.chartData.getBookYearOverrideValue());
			if (this.chartData.useToAddBanks){
				this.totalIncome += await ChartService.getTotalBank(this.chartData.toAddBanksFilters);
			}
			if (this.chartData.useToSubtractBanks){
				this.totalIncome -= await ChartService.getTotalBank(this.chartData.toSubtractBanksFilters);
			}
		}
	},
	created(){
		this.fetch();
	},
	components: {
		AppTinyInfo
	},
	i18nEx: {
		componentPrefix: "views.HomeRoute"
	}
});
